import { Box, Typography } from '@mui/material';
import { Chart, ChartOption } from '@/components/Base/Chart';
import type { RadarResponse } from '../types';

interface Props {
  data: RadarResponse | undefined;
  hasTurma: boolean;
}

const RadarChartTurma: React.FC<Props> = ({ data, hasTurma }) => {
  if (!hasTurma) {
    return (
      <Box
        sx={{
          background: '#fff',
          borderRadius: '14px',
          border: '1px solid rgba(176, 176, 176, 1)',
          p: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        height="400px"
      >
        <Typography color="#999" fontSize={14}>
          Selecione uma turma para ver o perfil de desempenho
        </Typography>
      </Box>
    );
  }

  if (!data || !data.disciplinas?.length || !data.valores?.length) {
    return (
      <Box
        sx={{
          background: '#fff',
          borderRadius: '14px',
          border: '1px solid rgba(176, 176, 176, 1)',
          p: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        height="400px"
      >
        <Typography color="#999" fontSize={14}>
          Carregando radar...
        </Typography>
      </Box>
    );
  }

  const option: ChartOption = {
    title: {
      text: `Perfil de Desempenho — ${data.turma_nome}`,
      textStyle: { fontSize: 14 },
    },
    tooltip: {},
    radar: {
      indicator: data.disciplinas.map((d) => ({ name: d, max: 10 })),
      shape: 'polygon',
    },
    series: [
      {
        type: 'radar',
        data: [
          {
            value: data.valores,
            name: data.turma_nome,
            areaStyle: { color: 'rgba(28, 156, 124, 0.3)' },
            lineStyle: { color: '#1c9c7c' },
            itemStyle: { color: '#1c9c7c' },
          },
        ],
      },
    ],
  };

  return (
    <Box
      sx={{
        background: '#fff',
        borderRadius: '14px',
        border: '1px solid rgba(176, 176, 176, 1)',
        p: '20px',
      }}
      height="400px"
    >
      <Chart option={option} />
    </Box>
  );
};

export default RadarChartTurma;
